export default function CTASection() {
  return (
    <section className="relative min-h-[420px] md:min-h-[500px] flex flex-col items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20night%20cityscape%20with%20paparazzi%20camera%20flashes%2C%20dark%20atmosphere%20with%20warm%20amber%20and%20golden%20light%20streaks%2C%20cinematic%20mood%2C%20mysterious%20vibe%2C%20blurred%20crowd%20in%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20luxury%20dark%20aesthetic&width=1920&height=1000&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-background-50 tracking-wide">
          不错过任何大瓜
        </h2>
        <p className="mt-4 text-background-50/80 text-sm md:text-base leading-relaxed max-w-md mx-auto">
          订阅911爆料网，第一时间接收网红翻车、明星黑料、综艺内幕等一手爆料
        </p>
        <div className="mt-8 flex justify-center">
          <a
            href="#category-grid"
            className="inline-flex items-center gap-3 pl-5 pr-6 py-3.5 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 hover:bg-foreground-800 whitespace-nowrap cursor-pointer group"
          >
            <span className="w-8 h-8 bg-accent-500 rounded-full flex items-center justify-center shrink-0">
              <i className="ri-notification-3-line text-background-50 text-base"></i>
            </span>
            <span>订阅爆料</span>
            <i className="ri-arrow-right-up-line text-lg transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
          </a>
        </div>
      </div>
    </section>
  );
}